export default "__VITE_ASSET__CYuJGT2$__"